"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;
const World = require("../lib/tileyo.js");
//World.use(DebugColliderPlugin);
const Gottimation_1 = require("../lib/Gottimation/Runtime/Gottimation");
const Pathfinder_1 = require("../lib/Pathfinder");
const resolutionSettings = {
    dynamicResolution: true,
    maxView: {
        w: 550,
        h: 350,
    },
};
const System_1 = require("../Systems/NPC/System");
const System_2 = require("../Systems/Input/System");
const System_3 = require("../Systems/PathFinding/System");
const System_4 = require("../Systems/PlayerAnimation/System");
const System_5 = require("../Systems/PlayerMovement/System");
const System_6 = require("../Systems/PlayerManager/System");
const System_7 = require("../Systems/PlayerAction/System");
const System_8 = require("../Systems/Timers/System");
const System_9 = require("../Systems/Tree/System");
const System_10 = require("../Systems/Level/System");
const System_11 = require("../Systems/Inventory/System");
const System_12 = require("../Systems/ItemDrop/System");
const System_13 = require("../Systems/Dialogue/System");
const System_14 = require("../Systems/NPCMovement/System");
const System_15 = require("../Systems/GameState/System");
const System_16 = require("../Systems/BugCatch/System");
const System_17 = require("../Systems/BugMovementAndAnimation/System");
const System_18 = require("../Systems/BugSpawn/System");
const System_19 = require("../Systems/BeeKeep/System");
const System_20 = require("../Systems/Flower/System");
const System_21 = require("../Systems/Dig/System");
const System_22 = require("../Systems/Shop/System");
const gotti_1 = require("gotti");
const Utils_1 = require("../../Shared/Utils");
const GottiGameInput_1 = require("../lib/GottiGameInput");
const GameData_1 = require("../../Shared/GameData");
exports.default = {
    isNetworked: false,
    type: 'island',
    systems: [
        System_15.GameStateSystem,
        System_11.InventorySystem,
        System_2.KeyboardInputSystem,
        System_10.LevelSystem,
        System_7.PlayerActionSystem,
        System_6.PlayerManagerSystem,
        System_3.PathfindingSystem,
        System_4.PlayerAnimationSystem,
        System_5.PlayerMovementSystem,
        System_1.NPCSystem,
        System_8.TimerSystem,
        System_9.TreeSystem,
        System_14.NPCMovementSystem,
        System_12.ItemDropSystem,
        System_13.DialogueSystem,
        System_16.BugCatchSystem,
        System_17.BugMovementSystem,
        System_18.BugSpawnSystem,
        System_19.BeeKeepSystem,
        System_20.FlowerSystem,
        System_21.DigSystem,
        System_22.ShopSystem,
    ],
    plugins: [],
    areas: [],
    globals(gameData, areaData, client) {
        return __awaiter(this, void 0, void 0, function* () {
            // if you add a new action here, youll probably need to edit the code in Input / System.ts -> resetState() -> add the new action string to the hard coded array.
            const gameInput = new GottiGameInput_1.default({
                keyboard: {
                    'moveDown': ["KeyS", "ArrowDown"],
                    'moveUp': ["KeyW", "ArrowUp"],
                    'moveLeft': ["KeyA", "ArrowLeft"],
                    'moveRight': ["KeyD", "ArrowRight"],
                    'inventory': ["KeyQ", "KeyShift"],
                    "pickup": ["Space", "KeyG"],
                    'cancel': ['Backspace', 'Delete', 'Escape'],
                    'grab': ["Enter"]
                },
                controller: {
                    default: {
                        buttons: {
                            'north': 'inventory',
                            'east': 'cancel',
                            'south': 'grab',
                            'west': 'pickup',
                            'select': 'inventory',
                            'start': 'pause',
                        },
                        dpad: {
                            south: 'moveDown',
                            west: 'moveLeft',
                            east: 'moveRight',
                            north: 'moveUp'
                        },
                        sticks: {
                            left: {
                                'moveLeft': { min: 225 - 22.5, max: 315 + 22.5 },
                                'moveRight': { min: 45 - 22.5, max: 135 + 22.5 },
                                'moveDown': { min: 135 - 22.5, max: 225 + 22.5 },
                                'moveUp': [{ min: 315 - 22.5, max: 360 }, { min: 0, max: 45 + 22.5 }]
                            },
                            right: {
                                'moveLeft': { min: 225 - 22.5, max: 315 + 22.5 },
                                'moveRight': { min: 45 - 22.5, max: 135 + 22.5 },
                                'moveDown': { min: 135 - 22.5, max: 225 + 22.5 },
                                'moveUp': [{ min: 315 - 22.5, max: 360 }, { min: 0, max: 45 + 22.5 }]
                            }
                        }
                    }
                },
            });
            gotti_1.default.emit('game-input', gameInput);
            const songUrls = [
                { url: 'Animal_Crossing_Chill_PM.wav', volume: .6 },
                { url: 'Animal_Crossing_Chill_PM.wav', volume: .6 },
                { url: 'Balanced_fixed_CrossingGame.mp3', volume: .1 },
                { url: 'Animal_Crossing_Hot_Summer.wav', volume: .6 },
                { url: 'Animal_Crossing_Hot_Summer.wav', volume: .6 },
                { url: 'Animal_Crossing_Start_Adventure.wav', volume: .6 },
                { url: 'Animal_Crossing_Start_Adventure.wav', volume: .6 },
                { url: 'Animal_Crossing_Start_Adventure_2.wav', volume: .6 },
                { url: 'Animal_Crossing_Start_Adventure_2.wav', volume: .6 },
                { url: 'music/Animal_Crossing_SNES.mp3', volume: .1 },
            ].map(p => {
                return { url: `Assets/music/${p.url}`, volume: p.volume };
            });
            const tryPlaySongs = (urls, platedUrls) => __awaiter(this, void 0, void 0, function* () {
                if (!urls.length) {
                    urls = [...platedUrls];
                    platedUrls.length = 0;
                }
                try {
                    const song = new Audio(urls[0].url);
                    song.volume = urls[0].volume;
                    yield song.play();
                    return new Promise((resolve, reject) => {
                        song.onended = () => {
                            platedUrls.push(urls.shift());
                            return resolve(tryPlaySongs(urls, platedUrls));
                        };
                    });
                    return new Promise((resolve, reject) => {
                        song.onended = () => {
                            return resolve(true);
                        };
                    });
                }
                catch (err) {
                    setTimeout(() => {
                        return tryPlaySongs(urls, platedUrls);
                    }, 200);
                }
            });
            tryPlaySongs(songUrls, []);
            // tryPlaySong();
            const canvas = document.getElementById("game-canvas");
            canvas.style.opacity = `1`;
            const fadeIn = () => __awaiter(this, void 0, void 0, function* () {
                const prev = parseFloat(canvas.style.opacity);
                const next = Math.min(prev + .01, 1);
                canvas.style.opacity = `${next}`;
                if (next < 1) {
                    if (prev <= .5 && next >= .5) {
                        gotti_1.default.emit('faded-in-halfway', true);
                    }
                    return new Promise((resolve, reject) => {
                        setTimeout(() => {
                            return resolve(fadeIn());
                        }, 1000 / 60);
                    });
                }
                return true;
            });
            let l = false;
            const fadeOut = (step = .01) => __awaiter(this, void 0, void 0, function* () {
                canvas.style.opacity = `${Math.max(parseFloat(canvas.style.opacity) - step, 0)}`;
                if (parseFloat(canvas.style.opacity) > 0) {
                    return new Promise((resolve, reject) => {
                        setTimeout(() => {
                            return resolve(fadeOut());
                        }, 1000 / 60);
                    });
                }
                return true;
            });
            const res = yield loadSpritesAndData();
            const textures = res['actextures'].textures;
            //console.error( textures['name_label_nook.png']);
            const inventoryTextures = {
                bear: textures['bear'],
                background: textures['inventory_background.png'],
                contextMenu: {
                    checkMark: textures['checkmark.png'],
                    background: textures['context_menu_background.png'],
                    selectedBackground: textures['context_menu_selected_option_background.png'],
                    pointer: textures['context_menu_pointer.png'],
                },
                item: {
                    labelBackgrounds: {
                        small: textures['name_label_small.png'],
                        medium: textures['name_label_medium.png'],
                        large: textures['name_label_long.png'],
                    },
                    emptyBackground: textures['unselected_inventory_icon.png'],
                    pointer: textures['inventory_pointer.png'],
                    selectedBackground: textures['selected_inventory_icon.png']
                }
            };
            const gameTextures = {
                animations: {
                    bugs: {
                        bee: [textures['bee1.png'], textures['bee2.png']]
                    }
                },
                honey: textures['honey_icon.png'],
                dialogue: {
                    nomTookBackground: textures['name_label_nook.png'],
                    name: {
                        small: textures['name_label_small.png'],
                        medium: textures['name_label_medium.png'],
                        large: textures['name_label_long.png'],
                    },
                    npc: {
                        nameLabel: textures['dialogue_name_background.png'],
                        dialogueBackground: textures['dialogue_background.png'],
                        continueIndicator: textures['dialogue_name_background.png'],
                    },
                    response: {
                        tallBackground: textures['context-menu-high.png'],
                        longBackground: textures['context_menu_long.png'],
                        background: textures['context_menu_background.png'],
                        selectedOptionBackground: textures['context_menu_selected_option_background.png'],
                        pointer: textures['context_menu_pointer.png'],
                    }
                },
                inventory: inventoryTextures,
                items: {
                    icons: {
                        net: textures['net_icon.png'],
                        shovel: textures['shovel_icon.png'],
                        hole: textures['hole_dug_up.png'],
                        tree: textures['tree.png'],
                        seeds1: textures['item0_seeds1.png'],
                        seeds2: textures['item1_seeds2.png'],
                        seeds3: textures['item2_seeds3.png'],
                        seeds4: textures['item3_seeds4.png'],
                        pedals1: textures['flower_pedals1.png'],
                        pedals2: textures['flower_pedals2.png'],
                        pedals3: textures['flower_pedals3.png'],
                        pedals4: textures['flower_pedals4.png'],
                        flower1: textures['flower1.png'],
                        flower2: textures['flower2.png'],
                        flower3: textures['flower3.png'],
                        flower4: textures['flower4.png'],
                        beehive: textures['beehive.png'],
                        sapling: textures['sapling.png'],
                        planted: textures['just_planted_seeds.png'],
                        bee: textures['bee1.png'],
                        red_bed: textures['items5_bed1.png'],
                        green_bed: textures['items6_bed2.png'],
                        blue_bed: textures['items7_bed3.png']
                    },
                    placed: {
                        net: textures['net_icon.png'],
                        shovel: textures['shovel_icon.png'],
                        hole: textures['hole_dug_up.png'],
                        tree: textures['tree.png'],
                        seeds1: textures['item0_seeds1.png'],
                        seeds2: textures['item1_seeds2.png'],
                        seeds3: textures['item2_seeds3.png'],
                        seeds4: textures['item3_seeds4.png'],
                        sapling: textures['sapling.png'],
                        planted: textures['just_planted_seeds.png'],
                        pedals1: textures['flower_pedals1.png'],
                        pedals2: textures['flower_pedals2.png'],
                        pedals3: textures['flower_pedals3.png'],
                        pedals4: textures['flower_pedals4.png'],
                        flower1: textures['flower1.png'],
                        flower2: textures['flower2.png'],
                        flower3: textures['flower3.png'],
                        flower4: textures['flower4.png'],
                        beehive: textures['beehive.png'],
                        bee: textures['bee1.png'],
                        red_bed: textures['placeable_bed1.png'],
                        green_bed: textures['placeable_bed2.png'],
                        blue_bed: textures['placeable_bed3.png']
                    }
                }
            };
            const renderer = initializeRenderer();
            const tileWorld = yield World.init(`Assets/ac3`, renderer, { resolutionSettings });
            yield tileWorld.loadMap('island');
            const waterRects = [
                {
                    "id": 0,
                    "x": 447,
                    "y": 509,
                    "w": 1152,
                    "h": 173
                },
                {
                    "id": 1,
                    "x": 455,
                    "y": 681,
                    "w": 53,
                    "h": 967
                },
                {
                    "id": 5,
                    "x": 1604,
                    "y": 511,
                    "w": 400,
                    "h": 1515
                },
                {
                    "id": 11,
                    "x": 490,
                    "y": 1652,
                    "w": 1113,
                    "h": 349
                },
                {
                    "id": 12,
                    "x": 1252,
                    "y": 1125,
                    "w": 199,
                    "h": 133
                }
            ];
            const grassRects = [
                {
                    "id": 2,
                    "x": 535,
                    "y": 729,
                    "w": 159,
                    "h": 338
                },
                {
                    "id": 3,
                    "x": 836,
                    "y": 738,
                    "w": 247,
                    "h": 127
                },
                {
                    "id": 4,
                    "x": 815,
                    "y": 994,
                    "w": 266,
                    "h": 189
                },
                {
                    "id": 0,
                    "x": 1172,
                    "y": 895,
                    "w": 70,
                    "h": 363
                },
                {
                    "id": 6,
                    "x": 1180,
                    "y": 731,
                    "w": 290,
                    "h": 143
                },
                {
                    "id": 7,
                    "x": 1481,
                    "y": 738,
                    "w": 92,
                    "h": 520
                },
                {
                    "id": 8,
                    "x": 1255,
                    "y": 905,
                    "w": 212,
                    "h": 193
                },
                {
                    "id": 9,
                    "x": 534,
                    "y": 1087,
                    "w": 161,
                    "h": 534
                },
                {
                    "id": 10,
                    "x": 820,
                    "y": 1215,
                    "w": 200,
                    "h": 391
                },
                {
                    "id": 1,
                    "x": 1179,
                    "y": 1271,
                    "w": 381,
                    "h": 110
                },
                {
                    "id": 14,
                    "x": 1040,
                    "y": 1400,
                    "w": 280,
                    "h": 200
                },
                {
                    "id": 15,
                    "x": 1328,
                    "y": 1400,
                    "w": 232,
                    "h": 200
                }
            ].map(rect => {
                return Object.assign(Object.assign({}, rect), { h: rect.h - 64, w: rect.w - 64 });
            });
            const bearSpawn = {
                level: "island",
                x: 760,
                y: 937,
            };
            /*
            allData.chunks.forEach(c => {
                c.layers.forEach( l => {
                   l?.colliders?.rects?.forEach(c => {
                       if(c.tags?.includes('grass')) {
                           if(!grassRects.find(r => r.id == c.id)) {
                               grassRects.push({ id: c.id, ...c.shapeData })
                           }
                       } else if (c.tags?.includes('water')) {
                           if(!waterRects.find(r => r.id == c.id)) {
                               waterRects.push({ id: c.id, ...c.shapeData })
                           }
                       }
                   });
                    l?.colliders?.points?.forEach(c => {
                        if(c.tags?.includes('start')) {
                      //      startingSpawn = { ...c.shapeData, level: 'island' }
                        } else if (c.tags?.includes('bear_spawn')) {
                            bearSpawn = { ...c.shapeData, level: 'island '}
                        }
                    });
                });
            });
    
             */
            const tempGameObjects = [];
            const tempData = GameData_1.defaultGameData('', grassRects, 50, [30, 20, 15, 5]);
            tempData.levels.find(l => l.name === 'island').state.items.forEach(i => {
                if (i.name === 'tree' || (i.name.includes('flower'))) {
                    tempGameObjects.push(tileWorld.addGameObject({
                        texture: gameTextures.items.placed[i.name],
                        position: { x: i.x, y: i.y },
                        layer: 1,
                    }));
                }
            });
            setTimeout(() => {
                gotti_1.default.emit('initial-map-load', true);
            }, 200);
            tileWorld.resolutionManager.calculate();
            const startPan = Utils_1.getRandomNumber(900, 1100);
            const panCameraPosition = { x: startPan, y: startPan };
            tileWorld.bindCameraCenter(panCameraPosition);
            tileWorld.update(1);
            const gottimation = yield Gottimation_1.Gottimation.Init(`Assets/acsnes`, { lazyLoadTextures: true, renderer, preloadAtlasDefaults: true }, tileWorld.loader);
            const pathfinder = new Pathfinder_1.GridPathFinder();
            pathfinder.create(16, 1024 / 16, 1024 / 16);
            let panningRight = true;
            let panningDown = true;
            let panSpeed = 30;
            let last = 0;
            const pan = () => {
                last = last || Date.now();
                const now = Date.now();
                const delta = (now - last) / 1000;
                last = now;
                if (panningRight) {
                    panCameraPosition.x += delta * panSpeed;
                    if (panCameraPosition.x > 1600) {
                        panningRight = false;
                    }
                }
                else {
                    panCameraPosition.x -= delta * panSpeed;
                    if (panCameraPosition.x < 350) {
                        panningRight = true;
                    }
                }
                if (panningDown) {
                    panCameraPosition.y += delta * panSpeed;
                    if (panCameraPosition.x > 1600) {
                        panningDown = false;
                    }
                }
                else {
                    panCameraPosition.y -= delta * panSpeed;
                    if (panCameraPosition.y < 350) {
                        panningDown = true;
                    }
                }
                panCameraPosition.x = Math.round(panCameraPosition.x);
                panCameraPosition.y = Math.round(panCameraPosition.y);
                tileWorld.update(delta);
                aniFrame = requestAnimationFrame(pan);
            };
            let aniFrame = requestAnimationFrame(pan);
            gotti_1.default.emit('initial-map-load', true);
            return new Promise((resolve, reject) => {
                gotti_1.default.once('player-enter', (payload) => __awaiter(this, void 0, void 0, function* () {
                    yield fadeOut(.005);
                    tempGameObjects.forEach(go => {
                        go.removeFromMap();
                    });
                    tempGameObjects.length = 0;
                    cancelAnimationFrame(aniFrame);
                    let gameStateData;
                    if (payload.isNew) {
                        gameStateData = GameData_1.defaultGameData(payload.data, grassRects);
                    }
                    else {
                        gameStateData = payload.data;
                    }
                    yield tileWorld.loadMap(gameStateData.level);
                    tileWorld.bindCameraCenter(gameStateData.position);
                    tileWorld.update(1);
                    return resolve({
                        totalElapsedTime: 0,
                        bearSpawn,
                        waterRects,
                        canvas,
                        gameInput,
                        gameTextures,
                        fadeIn,
                        fadeOut,
                        gameStateData,
                        playerCharacter: '',
                        spouseCharacter: '',
                        renderer,
                        gottimation,
                        tileWorld,
                        pathfinder,
                    });
                }));
            });
        });
    }
};
const loadSpritesAndData = () => __awaiter(void 0, void 0, void 0, function* () {
    const loader = PIXI.loader;
    loader.reset();
    [
        { name: 'goldlarge', url: 'Assets/fonts/goldlarge.fnt' },
        { name: 'gold', url: 'Assets/fonts/gold.fnt' },
        { name: 'gold2', url: 'Assets/fonts/gold2.fnt' },
    ].forEach(asset => {
        loader.add(asset.name, asset.url);
    });
    loader.add('actextures', 'Assets/sprites/actextures.json');
    return new Promise((resolve, reject) => {
        loader.load((loader, resources) => {
            return resolve(resources);
        });
    });
});
function initializeRenderer() {
    const canvas = document.getElementById("game-canvas");
    if (!canvas)
        throw new Error('Could not find canvas element with css selector id game-canvas');
    const renderer = PIXI.autoDetectRenderer({
        antialias: false,
        forceCanvas: false,
        roundPixels: false,
        autoResize: false,
        view: canvas,
    });
    if (typeof CSS !== 'undefined') {
        if (CSS.supports('(image-rendering: pixelated)')) {
            canvas.style.imageRendering = 'pixelated';
        }
        else if (CSS.supports('(image-rendering: crisp-edges)')) {
            canvas.style.imageRendering = 'crisp-edges';
        }
        else if (CSS.supports('(image-rendering: -webkit-crisp-edges)')) {
            canvas.style.imageRendering = '-webkit-crisp-edges';
        }
        else if (CSS.supports('(image-rendering: -moz-crisp-edges)')) {
            canvas.style.imageRendering = '-moz-crisp-edges';
        }
    }
    return renderer;
}
//# sourceMappingURL=module.js.map